import {
  UPDATE_IMMUTABLE_MULTI_SUBMENU,
  CLEAR_IMMUTABLE_MULTI_SUBMENU
} from "../actions";

export default function immutableMultiSubMenu(state = {}, action) {
  switch (action.type) {
    case UPDATE_IMMUTABLE_MULTI_SUBMENU:
      return { ...state, ...action.payload };
    case CLEAR_IMMUTABLE_MULTI_SUBMENU:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/immutableMultiSubMenu.js